import { gql } from "@apollo/client";

export default gql`
  mutation SuggestProduct($name: String!, $url: String) {
    suggestProduct(name: $name, url: $url) {
      _id
      name
      url
    }
  }
`;
